import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateDiscountGroupRequest,
} from './../discount-groups.actions'
import { getCreateDiscountGroupState } from './../discount-groups.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-discount-group',
  templateUrl: './create-discount-group.component.html',
  styleUrls: ['./create-discount-group.component.css'],
})
export class CreateDiscountGroupComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createDiscountGroup'))
    this.state$ = this.store
      .pipe(select(getCreateDiscountGroupState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createDiscountGroup.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createDiscountGroup',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      percentage: 'required|numeric|min:0|max:100',
      name: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state
      .get('data')
      .set('percentage', parseFloat(this.state.get('data').get('percentage')))
      .toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateDiscountGroupRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createDiscountGroup',
        ),
      )
    }
  }
}
